module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-00.1.4d18cb5d.jpg";